// Generated by Melange

import * as Buhta_cabinet__Box from "../../components/html/Box.js";
import * as Buhta_cabinet__Button from "../../components/html/Button.js";
import * as Buhta_cabinet__FormView from "../../components/html/FormView.js";
import * as Buhta_components__Text from "../../../../../packages/components/src/html/Text.js";
import * as Buhta_components__ToastContainer from "../../../../../packages/components/src/moleculas/ToastContainer.js";
import * as Curry from "melange.js/curry.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function LogoutForm(Props) {
  let payload = Props.payload;
  const match = React.useState(function () {
    
  });
  const setToast = match[1];
  let tmp;
  let exit = 0;
  if (payload !== undefined && typeof payload !== "string") {
    const variant = payload.NAME;
    if (variant === "AuthLogout") {
      const match$1 = payload.VAL;
      const return_to = match$1.return_to;
      tmp = JsxRuntime.jsxs(Buhta_cabinet__FormView.make, {
        onSubmit: (function (param) {
          
        }),
        action: "",
        method_: "POST",
        className: "mt-8",
        children: [
          JsxRuntime.jsx("input", {
            name: "token",
            type: "hidden",
            value: match$1.token
          }),
          JsxRuntime.jsx("input", {
            name: "return_to",
            type: "hidden",
            value: return_to
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx(Buhta_cabinet__Button.make, {
                kind: "default",
                isWide: true,
                onClick: (function (param) {
                  window.location.href = return_to;
                }),
                children: "Отмена"
              }),
              JsxRuntime.jsx(Buhta_cabinet__Button.make, {
                kind: "primary",
                type_: "submit",
                isWide: true,
                children: "Выйти"
              })
            ],
            className: "flex space-x-3 mt-4"
          })
        ]
      });
    } else if (variant === "AuthError") {
      const error = payload.VAL;
      const match$2 = error.reason;
      let tmp$1 = match$2 === "flow_expired" ? JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx("p", {
              children: "Сессия выхода истекла, начните заново.",
              className: "text-alert"
            }),
            JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
              className: "mt-6 text-gray-medium",
              children: JsxRuntime.jsx(Buhta_components__Text.Span.make, {
                className: "text-links",
                children: JsxRuntime.jsx("a", {
                  children: "Начать заново",
                  className: "link",
                  href: "/logout"
                })
              })
            })
          ],
          className: "flex flex-col space-y-2"
        }) : JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx("p", {
            children: error.message,
            className: "text-alert"
          }),
          className: "flex flex-col space-y-2"
        });
      tmp = JsxRuntime.jsx(Buhta_cabinet__Box.make, {
        title: "Ошибка",
        className: "relative",
        children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
          children: tmp$1
        })
      });
    } else {
      exit = 1;
    }
  } else {
    exit = 1;
  }
  if (exit === 1) {
    tmp = JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
      children: "Improper payload"
    });
  }
  return JsxRuntime.jsx(Buhta_components__ToastContainer.make, {
    toast: match[0],
    onExpired: (function (param) {
      Curry._1(setToast, (function (param) {
        
      }));
    }),
    children: JsxRuntime.jsxs(Buhta_cabinet__Box.make, {
      title: "Выход",
      className: "relative",
      children: [
        JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
          className: "text-gray-medium",
          children: "Подтвердите выход из платформы"
        }),
        tmp
      ]
    })
  });
}

const make = LogoutForm;

export {
  make,
}
/* Buhta_cabinet__Box Not a pure module */
